import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import paymentConfig from '../../../../constants/payment'
import { PAYMENT_CONFIG } from '../utils/paymentConfig'

interface Props {
  alipayUrl?: string
  wechatUrl?: string
  qrCodeInvalid?: boolean
  onRefresh?: (isClick?: boolean) => void
  channel?: number
  price?: number | string
  setChannel?: (c: number) => void
  alipayOnly?: boolean
  isContinuous?: boolean
  isCreatingOrder?: boolean
}

const PaymentQRCode: React.FC<Props> = ({
  alipayUrl,
  wechatUrl,
  qrCodeInvalid,
  onRefresh,
  channel,
  price,
  setChannel,
  alipayOnly = false,
  isContinuous = false,
  isCreatingOrder = false
}) => {
  const [localChannel, setLocalChannel] = useState<number | undefined>(channel)
  const [wechatLoaded, setWechatLoaded] = useState(false)
  const [alipayLoaded, setAlipayLoaded] = useState(false)

  useEffect(() => {
    setLocalChannel(channel)
  }, [channel])

  useEffect(() => {
    // 如果商品只支持支付宝支付，强制切换到支付宝
    if (alipayOnly && localChannel !== paymentConfig.channelType.Alipay) {
      setLocalChannel(paymentConfig.channelType.Alipay)
      if (setChannel) setChannel(paymentConfig.channelType.Alipay)
      onRefresh && onRefresh(true)
    }
  }, [alipayOnly, localChannel, setChannel, onRefresh])

  useEffect(() => {
    setWechatLoaded(false)
  }, [wechatUrl])

  useEffect(() => {
    setAlipayLoaded(false)
  }, [alipayUrl])

  return (
    <div className="payment-qr-card">
      <>
        <div
          className="tabs"
          role="tablist"
          style={{
            opacity: alipayOnly ? 0 : 1,
            pointerEvents: alipayOnly ? 'none' : 'auto'
          }}
        >
          <div
            className={`tab ${
              localChannel === paymentConfig.channelType.WeChat ? 'active' : ''
            }`}
            onClick={() => {
              if (
                localChannel !== paymentConfig.channelType.WeChat &&
                !alipayOnly
              ) {
                setLocalChannel(paymentConfig.channelType.WeChat)
                if (setChannel) setChannel(paymentConfig.channelType.WeChat)
                onRefresh && onRefresh(true)
              }
            }}
          >
            微信支付
          </div>
          <div
            className={`tab alipay ${
              localChannel === paymentConfig.channelType.Alipay ? 'active' : ''
            }`}
            onClick={() => {
              if (
                localChannel !== paymentConfig.channelType.Alipay &&
                !alipayOnly
              ) {
                setLocalChannel(paymentConfig.channelType.Alipay)
                if (setChannel) setChannel(paymentConfig.channelType.Alipay)
                onRefresh && onRefresh(true)
              }
            }}
          >
            支付宝支付
          </div>
        </div>

        <div className="payment-qr-header" style={{ marginTop: 12 }}>
          <div className="price-line">
            <span className="price-currency">¥</span>
            <span className="price-number">{price ?? ''}</span>
          </div>
        </div>

        <div className="payment-qr-body" style={{ marginTop: 16 }}>
          {qrCodeInvalid ? (
            <div className="qr-img invalid" style={{ position: 'relative' }}>
              <div
                className="payment-default-text"
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <div className="invalid-code">
                  {PAYMENT_CONFIG.MESSAGES.QR_CODE_INVALID}
                </div>
              </div>
              <div style={{ textAlign: 'center', zIndex: 2 }}>
                <div className="invalid-code" style={{ display: 'none' }}>
                  {PAYMENT_CONFIG.MESSAGES.QR_CODE_INVALID}
                </div>
                <div
                  className="update-code"
                  onClick={() => {
                    onRefresh && onRefresh(true)
                  }}
                  style={{ marginTop: 8 }}
                >
                  {PAYMENT_CONFIG.MESSAGES.CLICK_TO_REFRESH}
                </div>
              </div>
            </div>
          ) : (
            <>
              {wechatUrl && localChannel === paymentConfig.channelType.WeChat && (
                <div className="qr-img wechat" style={{ position: 'relative' }}>
                  {!wechatLoaded && (
                    <div
                      style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#fff',
                        zIndex: 5
                      }}
                    >
                      <Spin />
                    </div>
                  )}
                  <img
                    src={wechatUrl}
                    alt="wechat-qr"
                    style={{ display: wechatLoaded ? 'block' : 'none' }}
                    onLoad={() => setWechatLoaded(true)}
                  />
                </div>
              )}
              {alipayUrl && localChannel === paymentConfig.channelType.Alipay && (
                <div className="qr-img alipay" style={{ position: 'relative' }}>
                  {!alipayLoaded && (
                    <div
                      style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#fff',
                        zIndex: 5
                      }}
                    >
                      <Spin />
                    </div>
                  )}
                  <div style={{ display: alipayLoaded ? 'block' : 'none' }}>
                    <div className="iframe-container">
                      <div
                        className={`iframe-wrapper ${
                          isContinuous ? 'continuous' : ''
                        }`}
                      >
                        <iframe
                          id="alipay"
                          title="alipay"
                          scrolling="no"
                          src={alipayUrl}
                          onLoad={() => setAlipayLoaded(true)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {!(
                (localChannel === paymentConfig.channelType.WeChat &&
                  wechatUrl) ||
                (localChannel === paymentConfig.channelType.Alipay && alipayUrl)
              ) ? (
                <div className="qr-img" style={{ position: 'relative' }}>
                  {wechatUrl && (
                    <>
                      {!wechatLoaded && (
                        <div
                          style={{
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#fff',
                            zIndex: 5
                          }}
                        >
                          <Spin />
                        </div>
                      )}
                      <img
                        src={wechatUrl}
                        alt="wechat-qr"
                        style={{ display: wechatLoaded ? 'block' : 'none' }}
                        onLoad={() => setWechatLoaded(true)}
                      />
                    </>
                  )}
                  {alipayUrl && (
                    <>
                      {!alipayLoaded && (
                        <div
                          style={{
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#fff',
                            zIndex: 5
                          }}
                        >
                          <Spin />
                        </div>
                      )}
                      <div style={{ display: alipayLoaded ? 'block' : 'none' }}>
                        <iframe
                          title="alipay"
                          src={alipayUrl}
                          onLoad={() => setAlipayLoaded(true)}
                        />
                      </div>
                    </>
                  )}
                </div>
              ) : null}
            </>
          )}
        </div>

        <div className="payment-qr-footer" style={{ marginTop: 16 }}>
          <div className="scan-tip">
            {localChannel === paymentConfig.channelType.WeChat ? (
              <span style={{ color: '#00B424' }}>请使用微信扫码支付</span>
            ) : (
              <span style={{ color: '#0070F4' }}>请使用支付宝扫码支付</span>
            )}
          </div>
          <div className="agreement">
            开通前请查阅&nbsp;
            <span
              className="agreement-link"
              onClick={() =>
                window.open(
                  'https://www.xhey.top/x-vip_contract?app-hide-actions=1&version=2.2'
                )
              }
            >
              《会员协议》
            </span>
            {alipayOnly ? (
              <>
                <br />
                <span
                  className="agreement-link"
                  onClick={() =>
                    window.open(
                      'https://www.xhey.top/x-period_payment?app-hide-actions=1&version=2.2'
                    )
                  }
                >
                  《自动续费服务协议》
                </span>
              </>
            ) : null}
          </div>
        </div>
      </>
    </div>
  )
}

export default PaymentQRCode
